import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';
import { routeLocale } from '@/shared/lib/routeLocale';

export const shippingOptionsQuery = (locale = routeLocale()) =>
  defineQuery({
    queryKey: [...queryKeys.checkout.shippingOptions(), locale],
    queryFn: ({ signal }) => api.orders.listShippingOptions(signal),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
